export default "__VITE_ASSET__BljKn1Gx__"